module.exports = __webpack_public_path__ + "img/dailylog_title.c860b99f.png";